import React from "react";
import { observer, inject } from "mobx-react";
import CompareContainers from "./containers/Compare";
import { withRouter } from "react-router-dom";
import WithBanner from "Layouts/withBanner";
import Button from "ComponentsUI/Button";
import { isMainSiteCode } from "Utils/siteConfig";

@withRouter
@inject("ApplicationModel")
@observer
export default class CompareTariffications extends React.Component {
	onResetTariffsHandler() {
		let {
			ApplicationModel: { compareTarifficationsModel },
			history,
		} = this.props;
		let refererUrl = compareTarifficationsModel.refererUrl;

		let match = refererUrl.search(/\/rates/g);
		if (!compareTarifficationsModel.isClearTariffsClick) {
			compareTarifficationsModel.resetCompare();
		} else {
			compareTarifficationsModel.restoreCompare();
		}

		if (match > -1) {
			history.goBack();
		}
	}

	componentDidMount() {
		let {
			ApplicationModel: { compareTarifficationsModel },
		} = this.props;
		compareTarifficationsModel.setWidgetIsHide();
	}

	componentWillUnmount() {
		let {
			ApplicationModel: { compareTarifficationsModel },
		} = this.props;
		compareTarifficationsModel.setWidgetIsVisible();
	}

	render() {
		const { seoData } = this.props;
		let {
			ApplicationModel: { compareTarifficationsModel, text },
		} = this.props;
		const siteCode = this.props.ApplicationModel.siteCode;

		let buttonText = text.COMPARE_CLEAR;

		if (compareTarifficationsModel.isClearTariffsClick) buttonText = text.COMPARE_RESTORE;

		let button = (
			<Button
				typeText="big"
				size={"middle"}
				status={"withoutAccent"}
				fullWidth={true}
				transparent={true}
				onClick={() => this.onResetTariffsHandler()}
			>
				{buttonText}
			</Button>
		);

		return (
			<WithBanner
				bannerText={seoData && seoData.h1}
				withControllers={true}
				buttonControllers={button}
				route={this.props.route}
				seoData={seoData}
			>
				{isMainSiteCode(siteCode) && <div></div>}
				<CompareContainers />
			</WithBanner>
		);
	}
}
